(function () {
  var SETUP_THRESHOLD = 25;

  function init() {
    var roots = document.querySelectorAll('[data-tpu-tiers]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var tables = {
        standard: root.querySelector('[data-tpu-table="standard"]'),
        glitter: root.querySelector('[data-tpu-table="glitter"]')
      };
      var subtitle = root.querySelector('[data-tpu-tiers-subtitle]');
      var setupLabel = root.querySelector('[data-tpu-setup-label]');
      var setupFeeEl = root.querySelector('[data-tpu-setup-fee]');
      var bar = root.querySelector('[data-tpu-bar]');
      var barFill = root.querySelector('[data-tpu-bar-fill]');

      function render(qty, isGlitter) {
        qty = qty || 1;

        var activeKey = isGlitter ? 'glitter' : 'standard';
        Object.keys(tables).forEach(function (key) {
          if (!tables[key]) return;
          tables[key].hidden = key !== activeKey;
        });
        if (subtitle) {
          subtitle.textContent = (isGlitter ? 'Gold / Silver Glitter TPU' : 'Standard TPU & Metallic') + ' rate — per sq in';
        }

        var activeTable = tables[activeKey];
        if (activeTable) {
          activeTable.querySelectorAll('[data-tpu-row]').forEach(function (row) {
            var min = parseInt(row.getAttribute('data-min'), 10);
            var maxAttr = row.getAttribute('data-max');
            var max = maxAttr === '' ? Infinity : parseInt(maxAttr, 10);
            row.classList.toggle('is-current', qty >= min && qty <= max);
          });
        }

        var remaining = Math.max(0, SETUP_THRESHOLD - qty);
        var pct = Math.min(100, (qty / SETUP_THRESHOLD) * 100);
        if (bar) bar.setAttribute('aria-valuenow', String(Math.min(qty, SETUP_THRESHOLD)));
        if (barFill) {
          barFill.style.width = pct + '%';
          barFill.classList.toggle('is-complete', remaining === 0);
        }
        if (setupLabel) {
          setupLabel.textContent = remaining === 0
            ? 'Setup fee waived at 25+ units'
            : 'Add ' + remaining + ' more to waive the $15 setup fee';
        }
        if (setupFeeEl) {
          setupFeeEl.textContent = remaining === 0 ? 'Setup fee waived' : '$15.00 setup fee';
          setupFeeEl.classList.toggle('is-waived', remaining === 0);
        }
      }

      root.__tpuRender = render;
      render(1, false);
    });

    // Price breakdown display ("option A"): the big price shows the PATCH
    // price per piece only — floored so this line's patch total never reads
    // below the $10 order minimum — and the $15 setup fee is shown as its
    // own labeled line below, hidden once qty reaches 25 (waived). DPO still
    // CHARGES patch+setup combined per line; this is display decomposition
    // only. Cents used throughout to avoid floating-point glitches.
    var ORDER_MINIMUM_CENTS = 1000;
    // Fee lines render as siblings AFTER the whole first info item (the
    // "Price Per Each" row), not inside its content cell.
    function ensureFeeLine(list, className, html) {
      var item = list.closest('.product-form__info-item') || list.parentNode;
      var line = item.parentNode.querySelector('.' + className);
      if (!line) {
        line = document.createElement('div');
        line.className = className + ' tpu-setup-fee-line';
        line.innerHTML = html;
        item.parentNode.insertBefore(line, item.nextSibling);
      }
      return line;
    }
    function correctDisplayedPrice(vars) {
      var qty = Number(vars.qty) || 1;
      // Confirmed via PriceFormula.variables directly (qty:25, sqin:3.4225,
      // rate:0.5 -> perPatch:1.71125, min:3, pricedPatch:3): DPO's
      // pricedPatch is already the per-piece price with the per-patch
      // minimum floor applied — not a line total. No qty division needed;
      // the order-minimum check below multiplies back up to a line total.
      var pricedPatchCents = Math.round(Number(vars.pricedPatch) * 100);

      var display = '$' + (pricedPatchCents / 100).toFixed(2);
      document.querySelectorAll('.product-form__info-content .price-list .price[data-live-price]').forEach(function (el) {
        if (el.textContent !== display) el.textContent = display;
      });

      var waived = qty >= SETUP_THRESHOLD;
      var adjCents = Math.max(0, ORDER_MINIMUM_CENTS - pricedPatchCents * qty);

      document.querySelectorAll('.product-form__info-content .price-list').forEach(function (list) {
        var setupLine = ensureFeeLine(list, 'tpu-fee-setup',
          '<span class="product-form__info-title text--strong tpu-setup-fee-label">Setup Fee:</span> <span class="tpu-setup-fee-amount">$15.00</span> <span class="tpu-setup-fee-note">one-time per design &mdash; waived at 25+</span>');
        setupLine.style.display = waived ? 'none' : '';

        var adjLine = ensureFeeLine(list, 'tpu-fee-adjustment',
          '<span class="product-form__info-title text--strong tpu-setup-fee-label">Order Minimum Adjustment:</span> <span class="tpu-setup-fee-amount tpu-adj-amount"></span> <span class="tpu-setup-fee-note">orders have a $10.00 patch minimum</span>');
        var amt = adjLine.querySelector('.tpu-adj-amount');
        var amtText = '$' + (adjCents / 100).toFixed(2);
        if (amt && amt.textContent !== amtText) amt.textContent = amtText;
        adjLine.style.display = adjCents > 0 ? '' : 'none';
      });
    }

    window.jQuery && jQuery(window).on('dpoPriceUpdate', function () {
      if (!window.PriceFormula || !PriceFormula.variables) return;
      var vars = PriceFormula.variables;
      roots.forEach(function (root) {
        if (root.__tpuRender) root.__tpuRender(Number(vars.qty) || 1, !!vars.isGlitter);
      });
      correctDisplayedPrice(vars);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
